import { Routes } from '@angular/router';

import { FullComponent } from './layouts/full/full.component';
import { SessionGuard } from './shared/guards/session.guard';
import { UsersComponent } from './catalogs/users/users.component';
import { MenuGuard } from './shared/guards/menu.guard';

export const AppRoutes: Routes = [
    {
        path: '',
        component: FullComponent,
        children: [
            {
                path: '',
                redirectTo: '/home',
                pathMatch: 'full'
            },
            {
                path: 'home',
                loadChildren: () => import('./dashboards/dashboards.module').then(m => m.DashboardsModule)
            },
            {
                path: 'catalogs',
                loadChildren: () => import('./catalogs/catalogs.module').then(m => m.CatalogsModule)
            },
            {
                path: 'metrology',
                loadChildren: () => import('./metrology/metrology.module').then(m => m.MetrologyModule)
            },
            {
                path: 'certificates',
                loadChildren: () => import('./certifications/certifications.module').then(m => m.CertificationsModule)
            },
            {
                path: 'sales',
                loadChildren: () => import('./sales/sales.module').then(m => m.SalesModule)
            },
            {
                path: 'billing',
                loadChildren: () => import('./billing/billing.module').then(m => m.BillingModule)
            },
            {
                path: 'admin',
                loadChildren: () => import('./administration/administration.module').then(m => m.AdministrationModule)
            },
            {
                path: 'users', 
                component: UsersComponent,
                data: {
                  title: 'Usuarios',
                  urls: [
                    { title: 'Home', url: '/home' },
                    { title: 'Usuarios' }
                  ]
                },
                canActivate: [MenuGuard]
              },
        ],
        canActivate: [SessionGuard]
    },
    {
        path: 'authentication',
        loadChildren: () => import('./authentication/authentication.module').then(m => m.AuthenticationModule)
    },
    {
        path: '**',
        redirectTo: 'authentication/404'
    }
];
